import { Routes, Route, Navigate } from 'react-router-dom';
import * as paths from './paths';
import { Candidates } from '../Views/Candidates/Candidates';
import { CandidateDetail } from '../Views/CandidateDetail/CandidateDetail';
import { NotFound } from '../Views/NotFound/NotFound';
import { Jobs } from '../Views/Jobs/Jobs';
import { JobDetail } from '../Views/JobDetail/JobDetail';
import { Planner } from '../Views/Planner/Planner';
import { Reports } from '../Views/Reports/Reports';
import { Clients } from '../Views/Clients/Clients';
import ProtectedRoutesAuth from './ProtectedRoutes/ProtectedRoutesAuth';
import { UserError } from '../Views/UserError/UserError';
import ProtectedRouteUser from './ProtectedRoutes/ProtectedRouteUser';
import ProtectedRouteRole from './ProtectedRoutes/ProtectedRouteRole';
import { getRedirectHomePath } from './navigationUtils';
import { useAuthStore } from '../Stores/useAuthStore';

export const Router = () => {

  const { isAuthenticated, user } = useAuthStore();


  return (
    <Routes>

      <Route path={paths.HOME} element={<Navigate to={getRedirectHomePath(isAuthenticated, user)} />} />
      <Route element={<ProtectedRoutesAuth />}>
        <Route element={<ProtectedRouteUser />}>
          <Route element={<ProtectedRouteRole />}>
            <Route path={paths.CANDIDATES} key={paths.CANDIDATES} element={<Candidates />} />
            <Route path={paths.JOBS} key={paths.JOBS} element={<Jobs />} />
            <Route path={paths.REPORTS} key={paths.REPORTS} element={<Reports />} />
            <Route path={paths.CLIENTS} key={paths.CLIENTS} element={<Clients />} />
            <Route
              path={paths.CANDIDATE_DETAIL}
              key={paths.CANDIDATE_DETAIL}
              element={<CandidateDetail defaultTab={0} />}
            />
            <Route
              path={paths.CANDIDATE_DETAIL_JOBS}
              key={paths.CANDIDATE_DETAIL_JOBS}
              element={<CandidateDetail defaultTab={1} />}
            />
            <Route path={paths.JOB_DETAIL} key={paths.JOB_DETAIL} element={<JobDetail />} />
          </Route>
          <Route path={paths.PLANNER} key={paths.PLANNER} element={<Planner />} />
        </Route>
      </Route>
      <Route path={paths.NOT_FOUND} key={paths.NOT_FOUND} element={<NotFound />} />
      <Route path={paths.USER_ERROR} key={paths.USER_ERROR} element={<UserError />} />
    </Routes>
  )
};
